import { FETCH_BIKEMAKES_FAILURE, FETCH_BIKEMAKES_SUCCESS, FETCH_BIKEMAKES_REQUEST } from "../actions/types";

const initialState = {
    data: [],
    error: ''
};

export const bikeMakeReducer = (state = initialState, action) => {
    switch (action.type) {
        case FETCH_BIKEMAKES_REQUEST:
            return {
                ...state,
            }
        case FETCH_BIKEMAKES_SUCCESS:
            return {
                data: action.payload
            }
        case FETCH_BIKEMAKES_FAILURE:
            return {
                data: [],
                error: action.payload
            }
        default:
            return state;
    }
}